import type { ListBoxItemProps } from 'react-aria-components';
import { ListBoxItem as BaseListBoxItem } from 'react-aria-components';

import classes from './ListBoxItem.module.css';

type Props = ListBoxItemProps;

export const ListBoxItem = (props: Props) => {
  return <BaseListBoxItem className={classes.root} {...props} />;
};
